import { Extra, FoodType, Product, Service } from "@lemmonhq/types";
import { getAPIClient } from "../helpers";

export const catalogAPI = {
  getServices: async (): Promise<Service[]> => {
    const hc = getAPIClient();
    const req = await hc.api.catalog.services.$get();
    if (req.ok) {
      return req.json();
    } else {
      throw new Error("Failed to fetch services");
    }
  },

  getFoodTypes: async (): Promise<FoodType[]> => {
    const hc = getAPIClient();
    const foodTypesReq = await hc.api.v2.food_types.$get();
    if (foodTypesReq.ok) {
      const json = await foodTypesReq.json();
      return json;
    } else {
      throw new Error("Error fetching food types");
    }
  },

  getProducts: async (): Promise<Product[]> => {
    const hc = getAPIClient();
    const response = await hc.api.catalog.products.$get();
    if (!response.ok) {
      throw new Error("Failed to fetch products");
    }
    return response.json();
  },

  getExtras: async (): Promise<Extra[]> => {
    const hc = getAPIClient();
    const response = await hc.api.catalog.extras.$get();
    if (!response.ok) {
      throw new Error("Failed to fetch extras");
    }
    return response.json();
  },
  updateProductStatus: async (
    id: number,
    enabled: boolean,
  ): Promise<{ status: string }> => {
    const hc = getAPIClient();
    const response = await hc.api.catalog.products[":productId"].status.$put({
      param: { productId: id.toString() },
      json: {
        status: enabled ? "available" : "out_of_stock",
      },
    });
    if (!response.ok) {
      throw new Error("Failed to update product status");
    }
    return response.json();
  },
  updateExtraStatus: async (
    id: number,
    enabled: boolean,
  ): Promise<{ status: string }> => {
    const hc = getAPIClient();
    const response = await hc.api.catalog.extras[":extraId"].status.$put({
      param: { extraId: id.toString() },
      json: {
        status: enabled ? "available" : "unavailable",
      },
    });
    if (!response.ok) {
      throw new Error("Failed to fetch extras");
    }
    return response.json();
  },
};
